import React, { useEffect } from 'react';
import './assets/styles/auth.scss';
import { useDispatch } from 'react-redux';
import { removeCredentials } from './authSlice';
import { resetTheme } from '../../app/services/themeSlice';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const logoutProcess = async () => {
      // Dispatch actions to remove credentials and reset theme
      dispatch(removeCredentials());
      dispatch(resetTheme());

      // Navigate to the home page
      navigate('/login');

      // Reload the window
      // window.location.reload();

      // Redirect to a new URL after logout (e.g., home page or login page)
      window.location.href = '/login'; //
    };

    logoutProcess();
  }, [dispatch, navigate]);

  return <i>processing...</i>;
};
